import React, { useContext, useEffect, useRef } from "react";
import cn from "clsx";
import { useTranslation } from "react-i18next";
import GlobalShippingIcon from "@/images/global_shipping_background_white.svg";
import SizeHeadSection from "./sizeHeadSection";
import { MobileSizesContext } from "../productMobileSizes";

const ProductSizeList = ({ productSizes, isMultipleSize, isActive }) => {
  const { t } = useTranslation("productDetails");
  const sizeRef = useRef(null);

  const {
    onSizeSelection,
    selectedSizeFullData: { size: selectedSize },
    showProductSizeChart
  } = useContext(MobileSizesContext);

  useEffect(() => {
    sizeRef?.current?.scrollIntoView({ block: "nearest", inline: "center" });
  }, [productSizes, selectedSize]);

  if (!productSizes?.length) return null;
  return (
    <div className="mobile_size_wrapper">
      {!isMultipleSize && (
        <SizeHeadSection showProductSizeChart={showProductSizeChart} />
      )}
      <div className="mobile_size_list">
        <ul onClick={e => e.preventDefault()}>
          {productSizes.map(size => {
            if (!(size.sizeLabel || size.size)) return null;

            const isSizeChecked =
              isActive && selectedSize?.sizeId === size?.sizeId;
            const isOutOfStock = size.sizeStock <= 0;
            const isGlobalShipping = size.isGlobalShipping;

            const smallStockAmount =
              size?.sizeStock > 0 && size?.sizeStock <= 5;

            return (
              <li
                key={size.sizeId || size.size}
                onClick={() => {
                  !isOutOfStock && onSizeSelection(size);
                }}
                className={cn("size_item", {
                  selected_size: isSizeChecked,
                  size_not_available: isOutOfStock,
                  small_stock: smallStockAmount
                })}
                ref={isSizeChecked ? sizeRef : null}
              >
                {isGlobalShipping && (
                  <img
                    className="global_shipping_icon"
                    src={GlobalShippingIcon}
                  />
                )}
                {size.size}
              </li>
            );
          })}
        </ul>
        {selectedSize &&
          selectedSize.sizeStock <= 5 &&
          selectedSize.sizeStock > 0 && (
            <p className="size_quantity">
              {t("justPiecesLeft", { amount: selectedSize.sizeStock })}
            </p>
          )}
      </div>
    </div>
  );
};

export default ProductSizeList;
